import {gsap} from "gsap";
import {useGSAP} from '@gsap/react';
import {useRef} from "react";

export default function EinHead(props) {

    const container = useRef(null)

    useGSAP(() => {
        const timeline = gsap.timeline({ repeat: -1, repeatDelay: 4, delay: 4 });
        timeline.addLabel('first')
        timeline.to('[data-name="Eyebrow 1"]', {
            y: -8,
            rotate: -5,
            duration: 0.125,
            yoyo: true,
            repeat: 1,
        });
        timeline.addLabel('second')
        timeline.to('[data-name="Eyebrow 1"]', {
            y: -8,
            rotate: -5,
            duration: 0.125,
            yoyo: true,
            repeat: 1,
        });
        timeline.to('[data-name="Eyebrow 2"]', {
            y: -10,
            rotate: 5,
            duration: 0.125,
            yoyo: true,
            repeat: 1,

        }, 'first');
        timeline.to('[data-name="Eyebrow 2"]', {
            y: -10,
            rotate: 5,
            duration: 0.125,
            yoyo: true,
            repeat: 1,

        }, 'second');
    },{ scope: container });


    return (
        <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 224" ref={container}>
            <path fill="#545759" stroke="#333e48" strokeMiterlimit="10" strokeWidth="3.2" d="M169.7 171.7c14-7.2 52.1 8 57.4-12.9-10.6 8-11.6-.6-23.6 2.3 2.8-3.3 46.6-24.3 32-66.6-6.1 9.6-24 12.3-27.7 12.8 2.4-8.3 5.2-15.4 4.9-24.3-.5-12-18.8-51.5-58.5-65.8 6 9 11.8 25.6 7.5 42-1.9-6.7-6.9-21.6-7.5-23.5-2.2-7-17.2-23.3-35.6-26.5 8.9 13 9 22 8.8 30.2-22.1-11-21.6-29.9-21.8-36.6a86.7 86.7 0 0 0-47.3 28.5c-16.9 21-.3 30.1-9.9 47a40 40 0 0 0-27.1-14.9c14 18.3-4 34.3-8.2 41.2-11.5 19-3.4 31.8 1.6 37-3 .6-9.4-2-13-8.4-1.3 10.5 7.2 33.1 53.4 37-4 4.5-18.3 7.4-26.2 6.6a56 56 0 0 0 42-2s24.3 14.7 48.4 14.7 50.4-17.8 50.4-17.8Z" data-name="Hair"/>
            <path fill="#f2d4b3" stroke="#333e48" strokeMiterlimit="10" strokeWidth="3.2" d="M120.2 85.7h.2a49.4 49.4 0 0 1 49.3 49.3v39.5a30.4 30.4 0 0 1-30.4 30.4h-38a30.4 30.4 0 0 1-30.5-30.4V135a49.4 49.4 0 0 1 49.4-49.3Z" data-name="Face"/>
            <g fill="#333e48" fillRule="evenodd" data-name="Eyes">
                <path d="M97.5 150.5a5.9 5.9 0 1 1-11.7 0 5.9 5.9 0 0 1 11.7 0"/>
                <path d="M153 150.5a5.9 5.9 0 1 1-11.7 0 5.9 5.9 0 0 1 11.7 0"/>
            </g>
            <g data-name="Eyebrow 1">
                <path fill="#545759" d="M67 138.9a.8.8 0 0 1-.7-.3l-7.2-8.8a.8.8 0 0 1-.2-.6s0-.3.3-.5a51.2 51.2 0 0 1 45.8-7.6v.6l-3.8 10.7c-.1.3-.4.5-.8.5h-.2a38.8 38.8 0 0 0-33.3 6Z"/>
                <path fill="#333e48" d="M89.8 120.2c4.5 0 9 .6 13.4 1.8l-3.2 9.2a39.5 39.5 0 0 0-30.9 4.5l-2 1.3-6.2-7.5a49.6 49.6 0 0 1 28.9-9.4m0-3.1a53 53 0 0 0-31.5 10.4 2.4 2.4 0 0 0-.4 3.5l7.2 8.7a2.4 2.4 0 0 0 3.2.5 37.6 37.6 0 0 1 32.2-5.6c1 0 1.9-.6 2.2-1.5l3.8-10.7c.5-1.3-.3-2.7-1.6-3.1-4.9-1.5-10-2.2-15.1-2.2Z"/>
            </g>
            <g data-name="Eyebrow 2">
                <path fill="#545759" d="m172 139-.5-.1-1.5-1a39.2 39.2 0 0 0-31.6-4.8.8.8 0 0 1-.8-.5l-3.7-10.7a.8.8 0 0 1 .5-1 50.9 50.9 0 0 1 45.5 8.5l-.1.6-7.3 8.7c-.1.2-.3.3-.6.3Z"/>
                <path fill="#333e48" d="M149 120.3a49.3 49.3 0 0 1 29 9.3l-6.2 7.6-1-.6a40.8 40.8 0 0 0-32-5.3l-3.2-9.2c4.4-1.2 9-1.8 13.5-1.8m0-3.2c-5.1 0-10.3.7-15.2 2.2-1.3.4-2 1.8-1.6 3.1l3.8 10.7a2.4 2.4 0 0 0 3 1.5 37.4 37.4 0 0 1 31.5 5.6c.4.3.8.4 1.3.4.7 0 1.4-.3 1.9-.8l7.2-8.8c.9-1 .7-2.6-.4-3.4A52.8 52.8 0 0 0 149 117Z"/>
            </g>
            <path fill="#545759" stroke="#333e48" strokeMiterlimit="10" strokeWidth="3.2" d="M178.4 193a33.2 33.2 0 0 0-33.3-10l-2.3.8-2.6.6a3 3 0 0 0-1.4 1V173a2.2 2.2 0 1 0-4.4 0v13.6a15.4 15.4 0 0 1-30.7 0V173a2.2 2.2 0 1 0-4.5 0v11.5H99l-2.6-.7-2.2-.7c-13-3-23.7.3-33.4 10l-2.6 2.7a85 85 0 0 0 122-.8l-1.9-2Z" data-name="Moustache"/>
        </svg>
    )
}
